
export const nameButton = {
  createZone: {
    send: {
      name: 'Crear sub zona ',
      id: 'createSubZone'
    },
    update: {
      name: 'Actualizar sub zona ',
      id: 'update-s-z'
    },
    option: [
      {
        icon: 'keyboard_arrow_left',
        description: 'Volver',
        id: 'cancel'
      }
    ]
  },
  createZoneSpecial: {
    send: {
      name: 'Crear zona especial',
      id: 'createZoneEspecial'
    },
    update: {
      name: 'Actualizar zona especial',
      id: 'update-z-e'
    },
    option: [
      {
        icon: 'keyboard_arrow_left',
        description: 'Volver',
        id: 'cancel'
      }
    ]
  },
  buttonDefault: {
    send: {
      name: 'Guardar',
      id: 'send'
    },
    update: {
      name: 'Actualizar',
      id: 'update'
    },
    option: [
      {
        icon: 'keyboard_arrow_left',
        description: 'Volver',
        id: 'cancel'
      }
    ]
  },
  buttonSave: {
    send: {
      name: 'Guardar',
      id: 'send'
    },
  },
  iconsHelpers: {
    option: [
      {
        icon: 'sync',
        description: 'Limpiar filtros',
        id: 'clean-filter'
      }
    ]
  },
  onlyReturn: {
    option: [
      {
        icon: 'keyboard_arrow_left',
        description: 'Volver',
        id: 'cancel'
      }
    ]
  },
  cleanAndReturn: {
    option: [
      {
        icon: 'keyboard_arrow_left',
        description: 'Volver',
        id: 'cancel'
      },
      {
        icon: 'sync',
        description: 'Limpiar filtros',
        id: 'clean-filter'
      }
    ]
  },
  reportPicking: {
    option: [
      {
        icon: 'keyboard_arrow_left',
        description: 'Volver',
        id: 'cancel'
      },
      {
        iconSVG: 'eraser',
        description: 'Limpiar filtros',
        id: 'clean-filter'
      }
    ]
  },
  createQuotation: {
    buttons: [
      {
        icon: 'save',
        description: 'Guardar',
        id: 'saveQuotation',
        type: 'flat',
        items: false,
        menu: []
      },
      {
        iconSVG: 'flag',
        description: 'Emitir',
        id: 'finallyQuotation',
        type: 'flat',
        items: false,
        menu: []
      }
    ],
    option: [
      {
        iconSVG: 'eraser',
        description: 'Limpiar cotiz.',
        id: 'clean'
      }
    ]
  },
  updateQuotation: {
    buttons: [
      {
        iconSVG: 'cross',
        description: 'Anular',
        id: 'cancelQuotation',
        type: 'stroked',
        items: false,
        menu: []
      },
      {
        icon: 'save',
        description: 'Guardar',
        id: 'saveQuotation',
        type: 'flat',
        items: false,
        menu: []
      },
      {
        iconSVG: 'flag',
        description: 'Emitir',
        id: 'finallyQuotation',
        type: 'flat',
        items: false,
        menu: []
      }
    ],
    option: [
      {
        icon: 'keyboard_arrow_left',
        description: 'Volver',
        id: 'cancel'
      },
      {
        iconSVG: 'copy',
        description: 'Copiar cotiz.',
        id: 'copy'
      },
      {
        iconSVG: 'pdf',
        description: 'Exportar cotiz.',
        id: 'export-quotation'
      }
    ]
  }
};

